import React, { Component } from 'react';
import 'cropperjs/dist/cropper.css';
import Cropper from 'react-cropper';
import PropTypes from 'prop-types';

import CROPPER_CONFIG from './config';

import * as styles from './Cropper.scss';

class CropperComponent extends Component {
  cropperRef = (node) => { this.ref = node; }

  handleCropp = () => this.ref.cropper.getCroppedCanvas().toBlob((blob) => this.props.handleCropp(blob));

  rotateRight = () => {
    this.ref.cropper.rotate(90);
    this.ref.cropper.zoomTo(0);
  }
  rotateLeft = () => {
    this.ref.cropper.rotate(-90);
    this.ref.cropper.zoomTo(0);
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.iconCloseWrapper}>
          <i
            className="icon icon-close"
            onClick={this.props.hideCropperModal}
          />
        </div>
        <div className={styles.cropper}>
          <Cropper
            {...CROPPER_CONFIG}
            src={this.props.img}
            ref={this.cropperRef}
            cropstart={this.props.handleCropStart}
            cropend={this.props.handleCropEnd}
          />
        </div>
        <div className={styles.buttonsWrapper}>
          <button className={styles.rotateLeft} onClick={this.rotateLeft}>
            <i className="icon icon-rotate" />
          </button>
          <button className={styles.handleCropp} onClick={this.handleCropp}>
            {this.props.translate('cropImage')}
          </button>
          <button className={styles.rotateRight} onClick={this.rotateRight}>
            <i className="icon icon-rotate" />
          </button>
        </div>
      </div>
    );
  }
}

CropperComponent.propTypes = {
  img: PropTypes.string,
  translate: PropTypes.func,
  handleCropp: PropTypes.func,
  hideCropperModal: PropTypes.func,
  handleCropStart: PropTypes.func,
  handleCropEnd: PropTypes.func
};

export default CropperComponent;
